import {
    SET_SEARCHED_LAYER,
    SET_ADDITIONAL_LAYERS_DROPDOWN,
    SET_SCROLLING_TO_SEARCHED_LAYER
} from './Types';

export const setSearchedLayer = ({ category, systemName }:{category:string, systemName:string}) => {
    return ({ type: SET_SEARCHED_LAYER, category, systemName });
};
export const setAdditionalLayersDropdown = (value:any) => ({ type: SET_ADDITIONAL_LAYERS_DROPDOWN, value });
export const setScrollingToSearchedLayer = (value:any) => ({ type: SET_SCROLLING_TO_SEARCHED_LAYER, value });